import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import api from './api';
import store from "./store";

import "./assets/css/common.css";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import utils from './utils';
import PopupToast from "./pages/Public/PopupToast/PopupToast.js";

Vue.config.productionTip = false;
Vue.prototype.$api  = api;
Vue.prototype.$Utils  = utils;
Vue.prototype.$PopupToast = PopupToast;

Vue.use(ElementUI);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
